// A short, independent entrance: never waits for artwork, app modules, or a network request.
(() => {
 const layer = document.querySelector('#paint-intro');
 const replay = document.querySelector('#replay-intro');
 const skip = document.querySelector('#skip-intro');
 const reduced = matchMedia('(prefers-reduced-motion: reduce)');
 const sessionKey = 'trazos-paint-intro-seen';
 let timer, frame, previousFocus, playing = false;
 function allowed() {
  if (reduced.matches || document.body.classList.contains('motion-off')) return false;
  try { return localStorage.getItem('trazos-studio-motion') !== 'off'; } catch { return true; }
 }
 function syncReplay() {
  replay.disabled = !allowed();
  replay.title = replay.disabled ? 'Enable motion to replay the paint intro' : 'Replay the paint intro';
 }
 function finish() {
  const hadFocus = layer.contains(document.activeElement);
  clearTimeout(timer); cancelAnimationFrame(frame);
  playing = false;
  layer.classList.remove('is-playing');
  layer.hidden = true;
  if (hadFocus) (previousFocus?.matches('button,a,input') ? previousFocus : document.querySelector('#upload-zone')).focus({preventScroll:true});
 }
 function start() {
  if (playing || !allowed() || document.hidden) { finish(); return; }
  playing = true;
  previousFocus = document.activeElement;
  try { sessionStorage.setItem(sessionKey, 'yes'); } catch {}
  layer.hidden = false;
  // A new frame restarts the CSS sequence when the visitor chooses Replay.
  frame = requestAnimationFrame(() => layer.classList.add('is-playing'));
  timer = setTimeout(finish, 2800);
 }
 skip.addEventListener('click', finish);
 replay.addEventListener('click', start);
 layer.addEventListener('animationend', e => {
  if (e.animationName === 'paint-card') finish();
 });
 document.addEventListener('keydown', e => {
  if (playing && (e.key === 'Escape' || e.key === 'Tab')) finish();
 });
 document.addEventListener('visibilitychange', () => { if (document.hidden) finish(); });
 window.addEventListener('pagehide', finish);
 reduced.addEventListener('change', () => { syncReplay(); if (!allowed()) finish(); });
 new MutationObserver(() => { syncReplay(); if (!allowed()) finish(); })
  .observe(document.body, {attributes:true, attributeFilter:['class']});
 syncReplay();
 let seen = false;
 try { seen = sessionStorage.getItem(sessionKey) === 'yes'; } catch {}
 if (!seen) start(); else finish();
})();
